module.exports = __webpack_public_path__ + "img/15.257af4a1.png";